import { schema } from 'normalizr';
import collectionCategorySchema from './collectionCategory';
import labelSchema from './label';

const collectionEntrySchema = new schema.Entity('collectionEntries', {
  categories: [collectionCategorySchema],
  targets: [labelSchema],
});

export default collectionEntrySchema;
